import { IResourceComponentsProps } from "@refinedev/core";
import { MuiCreateInferencer } from "@refinedev/inferencer/mui";

export const CategoryCreate: React.FC<IResourceComponentsProps> = () => {
    return <MuiCreateInferencer />;
};
